import React, { useEffect, useState } from 'react';
import { Crown, Sparkles } from 'lucide-react';
import confetti from 'canvas-confetti';

const WelcomeBoss = ({ username, onComplete }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Fire confetti
        // First burst
        const fire = (particleRatio, opts) => {
            confetti(Object.assign({}, {
                origin: { y: 0.7 },
                colors: ['#Fbbf24', '#F59E0B', '#D97706', '#ffffff']
            }, opts, {
                particleCount: Math.floor(200 * particleRatio)
            }));
        };

        fire(0.25, { spread: 26, startVelocity: 55 });
        fire(0.2, { spread: 60 });
        fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
        fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
        fire(0.1, { spread: 120, startVelocity: 45 });
        // Continuous side bursts for 2.5 seconds
        const burstEnd = Date.now() + 2500;
        const frame = () => {
            confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: ['#Fbbf24', '#F59E0B', '#D97706'] });
            confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: ['#Fbbf24', '#F59E0B', '#D97706'] });
            if (Date.now() < burstEnd) requestAnimationFrame(frame);
        };
        frame();

        // Fazla bekletmeyelim, toplam süreyi 4 sn yapalım (0.5 sn fade out)
        const fadeTimer = setTimeout(() => setIsVisible(false), 3500);
        const removeTimer = setTimeout(() => onComplete(), 4000);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, [onComplete]);

    return (
        <div className={`fixed inset-0 z-[100] flex items-center justify-center bg-slate-950 transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-110'}`}>
            {/* Animasyonlu Arka Plan Işıkları */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-yellow-500/10 rounded-full blur-[100px] animate-pulse"></div>
            </div>

            <div className="text-center p-12 flex flex-col items-center glass border border-yellow-500/30 rounded-3xl shadow-[0_0_50px_rgba(234,179,8,0.15)] relative z-10 mx-4">

                <div className="relative mb-8 transform hover:scale-110 transition-transform duration-500 mt-4">
                    {/* Dönen ışık hüzmesi efekti */}
                    <div className="absolute inset-0 bg-gradient-to-tr from-yellow-400/0 via-yellow-400/40 to-yellow-400/0 rounded-full blur-xl animate-[spin_4s_linear_infinite] scale-150"></div>
                    <div className="absolute inset-0 bg-yellow-500/30 rounded-full blur-2xl animate-pulse"></div>

                    <Crown size={96} className="text-yellow-400 relative z-10 drop-shadow-[0_0_20px_rgba(250,204,21,0.6)]" />
                    <Sparkles size={40} className="text-yellow-300 absolute -top-4 -right-6 animate-bounce" />
                    <Sparkles size={24} className="text-yellow-200 absolute bottom-0 -left-6 animate-pulse" style={{ animationDelay: '500ms' }} />
                </div>

                <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 mb-6 tracking-tighter drop-shadow-2xl">
                    HOŞGELDİNİZ PATRON!
                </h1>

                <div className="w-24 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent mx-auto mb-6 opacity-50"></div>

                <p className="text-xl md:text-3xl text-slate-200 font-medium max-w-2xl leading-relaxed tracking-wide">
                    Sayın <span className="text-yellow-400 font-bold uppercase drop-shadow-md">{username}</span>,<br />
                    <span className="text-slate-400 text-lg md:text-xl mt-2 block font-normal">Sistem emrinize amade. İyi çalışmalar dileriz.</span>
                </p>

                {/* Yükleniyor Noktaları (Altın Renkli) */}
                <div className="mt-10 flex gap-3 justify-center">
                    <div className="w-3 h-3 rounded-full bg-yellow-500/80 animate-bounce shadow-[0_0_10px_rgba(234,179,8,0.5)]" style={{ animationDelay: '0ms' }}></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500/80 animate-bounce shadow-[0_0_10px_rgba(234,179,8,0.5)]" style={{ animationDelay: '150ms' }}></div>
                    <div className="w-3 h-3 rounded-full bg-yellow-500/80 animate-bounce shadow-[0_0_10px_rgba(234,179,8,0.5)]" style={{ animationDelay: '300ms' }}></div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeBoss;
